<!--
 * @Description:
 * @version:
 * @Author: knight
 * @Date: 2022-01-17 15:05:05
 * @LastEditors: knight
 * @LastEditTime: 2022-02-10 11:48:22
-->
<template>
  <div class="container">
    <div style="background-color: #f3f3f3">
      <div class="fixedsquare" :style="{ 'background-image': `url(${Topbg})` }">
        <img class="logo" src="../../assets/images/XLHZlogo1.png" />
        <div class="index">
          <Banner/>
          <!-- 跳转 -->
          <div class="box_enter">
            <router-link class="fl_bt" :to="{ path: '/activity/index' }">
              <div class="active_enter">
                <div class="left">
                  <div class="title YouShe">活动广场</div>
                  <div class="text">主播最新直播排期</div>
                </div>
                <div class="right">
                  <img
                    class="right_img"
                    src="https://xlhz.oss-cn-hangzhou.aliyuncs.com/miniProgram/images/activeTab.png"
                  />
                </div>
              </div>
            </router-link>

            <router-link class="fl_bt" :to="{ path: '/anchor/index' }">
              <div class="anchor_enter">
                <div class="left">
                  <div class="title YouShe">主播广场</div>
                  <div class="text">海量主播等你合作</div>
                </div>
                <div class="right">
                  <img
                    class="right_img"
                    src="https://xlhz.oss-cn-hangzhou.aliyuncs.com/miniProgram/images/anchorTab.png"
                  />
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <!-- 主播活动区域 -->
    </div>
    <!-- 跳转到更多活动 -->
    <router-link to="/activity/index">
      <div class="fl_bt" style="width: 100vw">
        <img
          class="more_img"
          src="https://xlhz.oss-cn-hangzhou.aliyuncs.com/miniProgram/images/more.png"
        />
      </div>
    </router-link>
    <!-- 主播列表 -->
    <Activity />
  </div>
</template>

<script>
import Activity from '@/pages/home/components/Activity.vue';
import Banner from '@/pages/home/components/Banner.vue';
export default {
  data() {
    return {
      // banners: [
      //   this.$miniProImagesPath('banner02.png'),
      // ],
      Topbg: this.$miniProImagesPath('index_top_bg.png'),
      homeData: [],
    };
  },
  mounted() {},
  methods: {},
  components: {
    Activity,
    Banner
  },
};
</script>

<style lang="less" scoped>
.container {
  position: fixed;
}
.fixedsquare {
  background-repeat: no-repeat;
  background-size: 100% 340px;
}
.index {
  padding: 20px 24px 0px;
}

.logo {
  width: 142px;
  height: 28px;
  left: 27px;
  margin-top: 40px;
  margin-left: 24px;
}

.g-banner {
  width: 100%;
  height: 240px;
}

.banner_image {
  width: 100%;
  height: 240px;
  overflow: hidden;
  border-radius: 20px;
}

.slide-image {
  width: 100%;
  height: 100%;
}

.box_enter {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.active_enter,
.anchor_enter {
  width: 341px;
  height: 158px;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;
}

.active_enter {
  background: linear-gradient(0deg, #ffffff 77.53%, #fffaf8 88.65%, #ffe9dd 100%);
}

.anchor_enter {
  background: linear-gradient(0deg, #ffffff 76.58%, #f3eeff 93.17%, #e9dfff 100%);
}

.title {
  font-size: 36px;
  color: #545454;
  margin-bottom: 20px;
  text-align: left;
}

.text {
  color: #545454;
  font-size: 20px;
}

.right {
  width: 100px;
  height: 104px;
}

.right .right_img {
  width: 100%;
  height: 100%;
}

.fl_bt {
  padding-top: 20px;
  text-align: center;
  font-size: 0px;
  background: #f3f3f3;
}

.more_img {
  width: 704px;
  height: 57px;
  border-radius: 20px 20px 0px 0px;
}

.icon {
  text-align: center;
  width: 29px;
  height: 29px;
  line-height: 29px;
}

.more {
  color: #545454;
}

.backBox {
  width: 100%;
  height: 100%;
  background-color: #999;
  z-index: 999;
  opacity: 0.5;
}

.painterImg {
  width: 638px;
  height: 891px;
  margin: 300px auto 40px;
  background: indianred;
  display: block;
}

.download_box {
  text-align: center;
  font-size: 32px;
  color: #fff;
}

.downloadImage {
  background-color: #e15443;
  background-image: url(https://xlhz.oss-cn-hangzhou.aliyuncs.com/miniProgram/images/Download.png);
  background-size: 40% auto;
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: 50%;
  border-radius: 50%;
  margin: 0 auto;
}
</style>
